__turbopack_context__.v({
  "placeholder": "placeholder-component-module-scss-module__xdBkUq__placeholder",
  "placeholder--error": "placeholder-component-module-scss-module__xdBkUq__placeholder--error",
  "placeholder--using-ratio": "placeholder-component-module-scss-module__xdBkUq__placeholder--using-ratio",
  "placeholder-shimmer": "placeholder-component-module-scss-module__xdBkUq__placeholder-shimmer",
  "placeholder__error-msg": "placeholder-component-module-scss-module__xdBkUq__placeholder__error-msg",
});
